<template>
    <div>
        <v-card>
            <v-row class="pa-3" v-if="componenteEvento.agregar_submodulo">
                <v-spacer></v-spacer>
                <ButtonComp @click="addItem" textButton="Agregar condición" iconBut="fas fa-plus" normalButton />
            </v-row>

            <ComundataTablecompVue :headers="CondicionAmisionHeaders" :items="condiciones" :search="search"
                :whitSearch="true" noResultsText="Sin datos para mostrar" placeholderTextsearch="Buscar">
                <template v-slot:grados="{ item }">
                    <span class="mr-2" v-for="grado in item.grados" :key="grado.id"> {{ grado.grado.desc_grado }} </span>
                </template>

                <template v-slot:action_editar="{ item }">
                    <ButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)"
                        tooltipText="Editar admisión" editButton />
                </template>

                <template v-slot:action_ver="{ item }">
                    <ButtonComp v-if="componenteEvento.visualizar_submodulo" @click="editItem(item, true)"
                        tooltipText="Ver admisión" verButton />
                </template>

                <template v-slot:action_borrar="{ item }">
                    <ButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)"
                        tooltipText="Eliminar admisión" deleteButton />
                </template>
            </ComundataTablecompVue>
        </v-card>
        <!--  FIN lIST DE REGISTROS --->


        <!-- modal para crear/editar
             condiciones -->
        <v-form ref="formDatos" lazy-validation>
            <ComunDialogComp v-model="dialog" maxWidth="700" :title="formTitle" @close-modal=" dialog = false">
                <template v-slot:body>
                    <v-row>
                        <!-- {{admisiones}} -->
                        <v-col md="6">
                            <AutocompleteComp v-model="editedItem.id_admision" textLabel="Año académico"
                                :items="parametros.admisiones" item-value="id" item-text="ano_academico"
                                :rules="validationRules.validateCampo" :readonly="bloquearCampo" />
                        </v-col>

                        <v-col md="6">
                            <AutocompleteComp @change="getGrados()" v-model="editedItem.id_nivel" textLabel="Nivel"
                                :items="niveles" item-value="id" item-text="desc_nivel"
                                :rules="validationRules.validateCampo" :readonly="bloquearCampo" />
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                            <AutocompleteComp v-model="editedItem.idsGrados" textLabel="Grado" :items="grados"
                                item-value="id" item-text="desc_grado" :rules="validationRules.validateCampo"
                                :readonly="bloquearCampo" multiple />
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:actions>
                    <v-spacer></v-spacer>
                    <ButtonComp v-if="evento == 'editar'" @click="editCondicion(editedItem.id)" textButton="Guardar cambios"
                        iconBut="fas fa-save" normalButton/>
                    <ButtonComp v-if="evento == 'agregar'" @click="addCondicion" textButton="Guardar"
                        iconBut="fas fa-save" normalButton />
                </template>
            </ComunDialogComp>

        </v-form>
        <!--------->





        <!-- //////////////Modal para confirmar eliminacion /////////////////////    -->
        <ComunDialogComp v-model="dialog_confirm" Confirmdialog @close-modal="dialog_confirm = false"
            :titleWindow="titlewindow" @cancel-item="funcionConfirm('no')" @confirm-item="funcionConfirm('si')">
            <template v-slot:body>
                {{ desc_confirm }} <br>
                {{ name_confirm }}
            </template>
        </ComunDialogComp>

        <ComunDialogComp v-model="dialog_confirmD" Deletedialog @close-modal="dialog_confirmD = false"
            @delete-item="funcionConfirm('si')" :titleWindow="titlewindow" @cancel-item="funcionConfirm('no')">
            <template v-slot:body>
                {{ desc_confirm }} <br>
                {{ name_confirm }}
            </template>
        </ComunDialogComp>


        <!-- fin de modal de borrar registro -->


    </div>
</template>





<script>
import axios from '../../../../helpers/axios'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { CondicionAmisionHeaders } from '../../../../helpers/headersTable';
import { validationRules } from '../../../../helpers/validatorHelpers';
import ComundataTablecompVue from "@/components/ComponentsEst/ComundataTablecomp.vue"
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';


export default {
    name: 'Configuracion',
    props: {
        parametros: {
            type: Object,
            default: Object
        },
    },
    components: {  ComundataTablecompVue, AutocompleteComp, ComunDialogComp, ButtonComp },
    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { 'id_submodulo': 141, "id_modulo": 5 }, //sud_modulo y modulo

        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////
        bloquearCampo: false,
        search: '',
        CondicionAmisionHeaders,




        //validaciones de formulario




        // modal agregar editar condicion
        dialog: false,
        titlewindow: "",
        deletedialog: false,
        confirmdialog: false,

        evento: '',
        editedItem: {},
        condiciones: [],
        niveles: [],
        grados: [],

        // modal confirmacion
        name_confirm: '',
        id_delete: null,
        dialog_confirm: false,
        dialog_confirmD : false,
        desc_confirm: '',
        eventoConfirm: ''
        //////////////////////////////////
    }),



    computed: {
        ...mapGetters('login', ['componenteEvento']),


        formTitle() {
            return this.evento === 'agregar' ? 'Agregar condición' : (this.evento === 'ver' ? 'Ver condición' : 'Editar condición')
        },
        validationRules() {
            return validationRules;
        },
    },

    mounted() {
        this.getCondiciones();
        this.getNivelesMantenimiento();

    },

    created() {
        this.actualizarParamentro();
        this.$emit('get-admisiones');
    },

    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////

        ////////  METODO QUE LIMPIA EL FORMULARIO Y VARIABLES /////////
        async limpiarForm() {
            this.editedItem = {
                id: 0, id_colegio: this.datoLogin.id_colegio,
                id_admision: "", grados: [], idsGrados: [], id_usuario: this.datoLogin.id
            };
            this.$refs.formDatos.resetValidation();
        },



        //////// METODO PARA HABILITAR MODAL PARA AGREGAR UN ITEM NUEVO //
        addItem() {
            this.getCondiciones()
            this.evento = 'agregar'
            this.limpiarForm();
            this.bloquearCampo = false;
            this.dialog = true
        },

        async getNivelesMantenimiento() {
            try {
                this.editedItem.idsGrados = [];
                // let response = await axios.get(`/mantenimiento/nivel/${this.datoLogin.id_colegio}`)
                let response = await axios.get(`/mantenimiento/nivel/${this.datoLogin.id_colegio}/`)
                this.niveles = response.data;
            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
            }
        },


        async getGrados() {
            try {
                this.editedItem.idsGrados = [];
                let response = await axios.get(`/mantenimiento/grado/${this.datoLogin.id_colegio}/${this.editedItem.id_nivel}/`);
                this.grados = response.data
            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
            }
        },

        async getCondiciones() {
            try {
                let response = await axios.get(`/admision/condicion/${this.datoLogin.id_colegio}`);
                this.condiciones = response.data;

            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
            }
        },

        //----------Crear Nueva Condicion ---------------
        async addCondicion() {

            if (this.$refs.formDatos.validate()) {
                let params = { ...this.editedItem, grados: this.editedItem.idsGrados }

                try {
                    let condicionExistente = this.condiciones.find(condicion => condicion.id_admision === this.editedItem.id_admision && condicion.id_nivel === this.editedItem.id_nivel)

                    if (condicionExistente) {
                        this.setEnviarMens({
                            tipo: "E",
                            mensaje: "Ya existe una condición con el mismo año académico y nivel. Para agregar otro grado, procesa a editar los niveles ya creados.",
                            tiempo: null
                        })
                        return;
                    }

                    let response = await axios.post("/admision/condicion/", params)

                    if (response.data.messageT == 'S') {
                        this.getCondiciones()

                        this.agregarOtraCondicion()
                    }

                    this.setEnviarMens({ tipo: response.data.messageT, mensaje: response.data.message, tiempo: null })
                }

                catch (e) {
                    this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
                }
            }

            else {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe de ingresar todos los campos requeridos`, tiempo: null })
            }
        },


        //---------------- Editar Condicion ----------------
        async editCondicion(id) {
            if (this.$refs.formDatos.validate()) {
                let params = { ...this.editedItem, grados: this.editedItem.idsGrados }
                try {
                    let response = await axios.put(`/admision/condicion/${id}`, params)
                    if (response.data.messageT == 'S') {
                        this.getCondiciones();
                        this.dialog = false
                        this.limpiarForm()
                    }
                    this.setEnviarMens({ tipo: response.data.messageT, mensaje: response.data.message, tiempo: null })
                } catch (e) {
                    this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
                }
            } else {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe de ingresar todos los campos requeridos`, tiempo: null })
            }
        },

        agregarOtraCondicion() {
            this.eventoConfirm = 'agregarOtraCondicion'
            this.dialog_confirm = true
            this.titlewindow = 'Agregar otra condición'
            
            this.desc_confirm = '¿Desea agregar otra condición?'
        },



        //------------FUNCION CONFIRMAR -------------
        async funcionConfirm(resp) {

            if (resp == 'si' && this.eventoConfirm == 'borrar') {
                this.deleteCondicion()
            }

            else if (resp == 'no' && this.eventoConfirm == 'borrar') {
                this.dialog_confirm = false
                this.dialog_confirmD = false
            }


            else if (resp == 'si' && this.eventoConfirm == 'agregarOtraCondicion') {
                this.dialog_confirm = false
                this.dialog_confirmD = false
                this.editedItem.id_admision = ''
                this.editedItem.idsGrados = [];
                this.$refs.formDatos.resetValidation()
            }

            else {
                this.dialog_confirm = false
                this.dialog_confirmD = false
                this.dialog = false
            }
        },




        //---------obtener datos pàra editar
        editItem(item, ver = false) {
            this.limpiarForm()
            this.evento = ver == true ? 'ver' : 'editar';
            if (ver == true) {
                this.bloquearCampo = true;
            } else {
                this.bloquearCampo = false;
            }
            this.getCondiciones()
            this.editedItem = Object.assign({}, item)
            this.getGrados();
            this.editedItem.idsGrados = item.grados.map(g => g.grado.id);
            this.dialog = true
        },


        // *****  confirmar el eliminar **********
        deleteConfirm(item) {
            this.eventoConfirm = 'borrar'
            this.dialog_confirmD = true
            this.id_delete = item.id
            this.name_confirm = `Condición: ${item.admision.ano_academico} (${item.nivel.desc_nivel})`
            this.desc_confirm = "¿Está seguro de eliminar este registro?"
            this.titlewindow = "Eliminar condición"
        },



        //------------ borrar condición -------------
        async deleteCondicion() {
            try {
                let response = await axios.delete(`/admision/condicion/${this.id_delete}`)
                this.dialog_confirm = false
                this.dialog_confirmD = false

                if (response.data.messageT == "S") {
                    this.getCondiciones();
                }

                this.setEnviarMens({ tipo: response.data.messageT, mensaje: response.data.message, tiempo: null })
            } catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
            }
        },


    }
}
</script>




<style scoped>
.chip {
    width: 100%;
    height: 100%;
    text-align: center;
    padding-top: 15px;
    color: #ffffff;
}
</style>